import { Application } from "@hotwired/stimulus"
const Stimulus = Application.start()

import CollapseCheckController from "./collapse_check_controller"
import BmsWidgetFormController from "./bms-widget-form-controller"
import OpenModalController from "./open-modal-controller"
import PasswordMaskToggleController from "./password_mask_toggle_controller"
import IframeResizerController from "./iframe-resizer-controller"
import CopyButtonController from "./copy-button-controller"
import TranslateController from "./translate_controller"
import AlertCloseController from "./alert_close_controller"
import HighchartsController from "./highcharts_controller"
import TagCloudController from "./tagcloud_controller"
import PasswordMaskController from "./password-mask-controller"
import CurrencyMaskController from './currency-mask-controller'
import SelectAllController from './select-all-controller'
import ApplySummaryController from './apply-summary-controller'
import SequenceApplyController from './sequence-apply-controller'
import CopyController from './copy_controller'
import EventInviteController from './event_invite_controller'
import ReviewSuggestionController from './review_suggestion_controller'

import ReadMore from 'stimulus-read-more'
import { Autocomplete } from 'stimulus-autocomplete'

import TabsController from './common/tabs-controller'
import Reveal from './common/reveal-controller'
import CounterController from './common/counter-controller'
import StickyCtaController from './common/sticky-cta-controller'
import ShowMoreController from './common/show-more-controller'
import PriceCalculatorController from './common/price-calculator-controller'
import OfferFormController from './common/offer-form-controller'
import PricingQuoteController from './common/pricing-quote-controller'
import DialogController from './common/dialog-controller'

import ChoicesController from './lib/choices-controller'
import TinymceController from './lib/tinymce-controller'

import CoworkrSubscribersTableController from './coworkr_subscribers_table_controller'
import CoworkrNewsletterPreviewController from './coworkr_newsletter_preview_controller'
import CoworkrImpersonateController from './coworkr_impersonate_controller'
import CoworkrBannerPickerController from './coworkr_banner_picker_controller'
import CoworkrColorPickerController from './coworkr_color_picker_controller'
import EbmsImportController from './ebms_import_controller'

import CrmPricingController from './registration/crm-pricing-controller'
import WalkInController from './registration/walk-in-controller'
import WalkInJobController from './registration/walk-in-job-controller'
import SalaryIntervalController from './registration/salary-interval-controller'
import PostcodeAutocompleteController from './registration/postcode-autocomplete-controller'
import FormErrorsController from './registration/form-errors-controller'

Stimulus.register("collapse-check", CollapseCheckController)
Stimulus.register("bms-widget-form", BmsWidgetFormController)
Stimulus.register("open-modal", OpenModalController)
Stimulus.register("password-mask-toggle", PasswordMaskToggleController)
Stimulus.register("iframe-resizer", IframeResizerController)
Stimulus.register("tabs", TabsController)
Stimulus.register("copy-button", CopyButtonController)
Stimulus.register("translate", TranslateController)
Stimulus.register("alert-close", AlertCloseController)
Stimulus.register("highcharts", HighchartsController)
Stimulus.register("tagcloud", TagCloudController)
Stimulus.register("password-mask", PasswordMaskController)
Stimulus.register('currency-mask', CurrencyMaskController)

Stimulus.register('read-more', ReadMore)
Stimulus.register('autocomplete', Autocomplete)

Stimulus.register('reveal', Reveal)
Stimulus.register('counter', CounterController)
Stimulus.register('sticky-cta', StickyCtaController)
Stimulus.register('show-more', ShowMoreController)

Stimulus.register('tinymce', TinymceController)
Stimulus.register('choices', ChoicesController)

Stimulus.register('price-calculator', PriceCalculatorController)
Stimulus.register('offer-form', OfferFormController)
Stimulus.register('pricing-quote', PricingQuoteController)
Stimulus.register('dialog', DialogController)

Stimulus.register('crm-pricing', CrmPricingController)
Stimulus.register('walk-in', WalkInController)
Stimulus.register('walk-in-job', WalkInJobController)
Stimulus.register('salary-interval', SalaryIntervalController)
Stimulus.register('postcode-autocomplete', PostcodeAutocompleteController)
Stimulus.register('form-errors', FormErrorsController)

Stimulus.register('select-all', SelectAllController)
Stimulus.register('apply-summary', ApplySummaryController)
Stimulus.register('sequence-apply', SequenceApplyController)
Stimulus.register('coworkr-subscribers-table', CoworkrSubscribersTableController)
Stimulus.register('coworkr-newsletter-preview', CoworkrNewsletterPreviewController)
Stimulus.register('coworkr-impersonate', CoworkrImpersonateController)
Stimulus.register('coworkr-banner-picker', CoworkrBannerPickerController)
Stimulus.register('coworkr-color-picker', CoworkrColorPickerController)
Stimulus.register('ebms-import', EbmsImportController)
Stimulus.register('copy', CopyController)
Stimulus.register('event-invite', EventInviteController)
Stimulus.register('review-suggestion', ReviewSuggestionController)
